// extracted by mini-css-extract-plugin
module.exports = {"Container":"FileTree_Container__2RReg","SearchWrapper":"FileTree_SearchWrapper__1SGp1","Dir":"FileTree_Dir__zVw_b","FilteredTreeNode":"FileTree_FilteredTreeNode__1elfr"};